import { useEffect, useState } from 'react';
import { api } from '../api/api';
import { Category, Product } from '../types';
import { ProductCard } from '../components/ProductCard';
import { Button } from '@/components/ui/button';

export function CatalogPage() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [categoriesData, productsData] = await Promise.all([
        api.getCategories(),
        api.getProducts(),
      ]);
      setCategories(categoriesData);
      setProducts(productsData);
    } catch (err) {
      setError('Не удалось загрузить данные');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredProducts = selectedCategory
    ? products.filter(p => p.categoryId === selectedCategory)
    : products;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px] text-muted-foreground">
        Загрузка...
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 m-4 bg-destructive/10 text-destructive rounded-lg">
        {error}
      </div>
    );
  }

  return (
    <div className="pb-20">
      <header className="sticky top-0 z-10 bg-background border-b px-4 py-5">
        <h1 className="text-2xl font-bold">Каталог</h1>
      </header>

      {categories.length > 0 && (
        <div className="flex gap-2 p-4 overflow-x-auto scrollbar-hide">
          <Button
            variant={selectedCategory === null ? "default" : "secondary"}
            size="sm"
            className="flex-shrink-0 rounded-full"
            onClick={() => setSelectedCategory(null)}
          >
            Все
          </Button>
          {categories.map(category => (
            <Button
              key={category.id}
              variant={selectedCategory === category.id ? "default" : "secondary"}
              size="sm"
              className="flex-shrink-0 rounded-full"
              onClick={() => setSelectedCategory(category.id)}
            >
              {category.name}
            </Button>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 px-4">
        {filteredProducts.length === 0 ? (
          <div className="col-span-full text-center py-16 text-muted-foreground">
            <p>Товары не найдены</p>
          </div>
        ) : (
          filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))
        )}
      </div>
    </div>
  );
}
